import { computed, toValue, watch } from 'vue';
import { getSportLiveTvTeams } from '@/api/sport-live-tv';
import { useAsyncData } from '@/composables/use-async-data';
import { SPORT_LIVE_TV_TEAMS_LIMIT } from '@/sport-live-tv/constants';

export const useSportLiveTvTeams = (search) => {
  const { data, execute } = useAsyncData(() => getSportLiveTvTeams(toValue(search), 0, SPORT_LIVE_TV_TEAMS_LIMIT));

  watch(() => toValue(search), execute);

  return computed(() => data.value ?? []);
};
